const VISITOR_ID_KEY = 'lex_visitor_id';
const DEDUPE_MS = 60_000;
const lastSentByPath = new Map();

function readVisitorId() {
    if (typeof window === 'undefined') return null;
    try {
        const existing = window.localStorage.getItem(VISITOR_ID_KEY);
        if (existing) return existing;
        const id = window.crypto?.randomUUID?.() || `v-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        window.localStorage.setItem(VISITOR_ID_KEY, id);
        return id;
    } catch {
        return null;
    }
}

function parseUtm(search) {
    if (!search) return {};
    const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
    return {
        utm_source: params.get('utm_source') || null,
        utm_medium: params.get('utm_medium') || null,
        utm_campaign: params.get('utm_campaign') || null,
    };
}

function shouldSkip(pathname, search) {
    const key = `${pathname}${search || ''}`;
    const now = Date.now();
    const last = lastSentByPath.get(key);
    if (last && now - last < DEDUPE_MS) return true;
    lastSentByPath.set(key, now);
    return false;
}

/** Queue a page view for logging (call from SiteVisitTracker). */
export function buildSiteVisitPayload(pathname, search = '') {
    const visitorId = readVisitorId();
    if (!visitorId || !pathname) return null;
    if (shouldSkip(pathname, search)) return null;

    const utm = parseUtm(search);
    return {
        visitorId,
        path: pathname,
        search: search || null,
        referrer: typeof document !== 'undefined' ? (document.referrer || null) : null,
        userAgent: typeof navigator !== 'undefined' ? (navigator.userAgent || null) : null,
        ...utm,
    };
}
